import { DataAccess } from "../../dataaccess/data.access";
import { AccessLevel, AccessLevels, isMinFls } from "../../pojo/Fls";
import { Cache } from "../../decorators/cache.decorator";
import { RoleRights } from "./securityConfig/role.rights";
/**
 * Response from getSeRights endpoint
 */
export interface SeRightsResponse {
    flsValue: AccessLevel;
    maxRights: Record<RoleRights.RoleRightsList, AccessLevel>;
    orgRights: Record<number, Record<RoleRights.RoleRightsList, AccessLevel>>;
}

/**
 * Service for checking Student Engagement role-based security rights
 * Provides access level information for the current user
 */
export class RoleRightsAccessService {
    @Cache({ immutable: true, targetName: "RoleRightsSecurityService" })
    public static getSeRights(organizationId?: number[]): Promise<SeRightsResponse> {
        return DataAccess.post<SeRightsResponse>(`/role/rights/check.json?request_method=get`, {
            post_get: { organization_id: organizationId?.join("+") },
        });
    }

    public static async hasMinAccess(
        rightName: RoleRights.RoleRightsList,
        minAccessLevel: AccessLevels,
    ): Promise<boolean> {
        const rights = await this.getSeRights();
        const actualAccess = (rights.maxRights[rightName] || AccessLevels.None) as AccessLevels;
        return isMinFls(actualAccess, minAccessLevel);
    }

    public static async hasMinAccessForOrg(
        rightName: RoleRights.RoleRightsList,
        organizationId: number,
        minAccessLevel: AccessLevels,
    ): Promise<boolean> {
        const rights = await this.getSeRights([organizationId]);
        if (!rights.orgRights) {
            return false;
        }
        const actualAccess = (rights.orgRights[organizationId][rightName] || AccessLevels.None) as AccessLevels;
        return isMinFls(actualAccess, minAccessLevel);
    }
}
